import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['tab', 'panel']

  connect() {
    this.showTab(0)
  }

  switch(event) {
    event.preventDefault()
    const index = parseInt(event.currentTarget.dataset.index)
    this.showTab(index)
  }

  showTab(index) {
    this.tabTargets.forEach((tab, i) => {
      const active = i === index
      tab.classList.toggle('border-yellow-400', active)
      tab.classList.toggle('text-gray-900', active)
      tab.classList.toggle('border-transparent', !active)
      tab.classList.toggle('text-gray-500', !active)
    })
    this.panelTargets.forEach((panel, i) => {
      panel.classList.toggle('hidden', i !== index)
    })
  }
}
